export class ConfirmModal {

    constructor(public title: string, public content: string,
                public confirmButton = 'Confirm',
                public cancelButton = 'Cancel') {
    }
}
